<template>
  <div id="userManagement">
    <!-- 头部下拉框select -->
    <div class="top_select">
      <span v-if="agent==1">{{$t('common.Role')}}：</span>
      <div v-if="agent==1">
        <allSelect
          @on-change="searchEvent"
          :chooseData="roleList"
          :needReturn="'Code'"
          :matchValue="'Name'"
          :showValue="'{{Name}}'"
          v-model="postData.roleCode"
        >
        </allSelect>
      </div>
      <span v-if="agent==3">{{$t('common.SysNotification')}}：</span>
      <div v-if="agent==3">
        <allSelect
          @on-change="onOffEvent"
          :chooseData="onOffSeltList"
          :needReturn="'Code'"
          :matchValue="'Name'"
          :showValue="'{{Name}}'"
          v-model="postData.onOffSelt"
        >
        </allSelect>
      </div>
      <span class="m_l_10">{{$t('common.Keyword')}}：</span>
      <div>
        <input type="text" style="font-size: 12px;width: 200px;" class="allInput"
               :placeholder="$t('common.KeywordPlaceHolder')" v-model="postData.searchKey" @keyup.enter="searchEvent()">
      </div>
      <div class="m_l_10">
        <button class="redButton" @click="searchEvent()">{{$t('common.Search')}}</button>
        <button class="cancelButtonRed m_l_10" @click="allReset()">{{$t('common.Reset')}}</button>
      </div>
    </div>
    <!-- 表格上方切换角色  获取年份 -->
    <div class="switch_role">
      <div class="button_group">
        <span
          class="c_p t_c"
          :class="agent==1 ? 'active' : ''"
          @click="agent = 1"
        >{{$t('common.Saleser')}}</span>
        <span
          class="c_p t_c"
          :class="agent==2 ? 'active' : ''"
          @click="agent = 2"
        >{{$t('common.OtherRoles')}}</span>
        <span
          class="c_p t_c"
          :class="agent==3 ? 'active' : ''"
          @click="agent = 3"
        >{{$t('common.SysUserGroup')}}</span>
      </div>
    </div>
    <!-- 表格 table -->
    <div class="card">
      <div class="add_sysuser d_f">
        <div @click="onOrderby" v-if="agent==1" class="c_p">
          <i class="icon iconfont icon-paixu"></i>
          <span>{{ order ? $t('common.BlandSort') : $t('common.DefaultSort') }}</span>
        </div>
        <div @click="onSysuserAddShow" v-if="agent==2" class="c_p">
          <i class="icon iconfont icon-tianjia"></i>
          <span>{{$t('common.AddUser')}}</span>
        </div>
      </div>
      <template v-if="agent==1">
        <table class="sales">
          <thead>
          <tr>
            <td>{{$t('common.Role')}}</td>
            <td>Territory Code</td>
            <td>Territory Name</td>
            <td>{{$t('common.Name')}}</td>
            <td>{{$t('common.Email')}}</td>
            <td>{{$t('common.Delegator')}}</td>
            <td>{{$t('common.Email')}}</td>
            <td>{{$t('common.Action')}}</td>
          </tr>
          </thead>
          <tbody>
          <template v-if="agentDta.items && agentDta.items.length !== 0">
            <tr
              v-for="(item, index) in agentDta.items"
              :key="'agentDta1' + index"
            >
              <td>{{ item.TerritoryLevel }}</td>
              <td>{{ item.TerritoryCode }}</td>
              <td>{{ item.TerritoryName }}</td>
              <td>{{ item.EmployeeName }}</td>
              <td>{{ item.EmployeeEmail }}</td>
              <td class="daili">
                <div
                  v-for="(item, index) in item.Agents"
                  :key="'Agents2' + index"
                >
                  {{ item.AgentName }}
                </div>
              </td>
              <td class="daili">
                <div v-for="(item, index) in item.Agents" :key="'Agents'+index">
                  {{ item.AgentEmail }}
                </div>
              </td>
              <td>
                <i
                  class="icon iconfont icon-bianji c_p"
                  @click="agentEdit(item)"
                ></i>
              </td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="8">{{$t('common.noData')}}</th>
          </tr>
          </tbody>
        </table>
        <page
          :totalPage="agentDta.pages"
          :page="agentDta.offset"
          @on-getList="agentPageChange"
          v-if="agentDta.items && agentDta.items.length !== 0"
        ></page>
      </template>
      <template v-if="agent==2">
        <table class="sysuser">
          <thead>
          <tr>
            <td>{{$t('common.Role')}}</td>
            <td>{{$t('common.Name')}}</td>
            <td>{{$t('common.Email')}}</td>
            <td>{{$t('common.Action')}}</td>
          </tr>
          </thead>
          <tbody>
          <template
            v-if="sysuserData.items && sysuserData.items.length !== 0"
          >
            <tr v-for="(item, index) in sysuserData.items" :key="'sysuserData'+index">
              <td>{{ item.Role }}</td>
              <td>{{ item.Name }}</td>
              <td>{{ item.Email }}</td>
              <td>
                <i
                  class="icon iconfont icon-lajitong c_p"
                  @click="sysuserDel(item)"
                ></i>
              </td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="4">{{$t('common.noData')}}</th>
          </tr>
          </tbody>
        </table>
        <page
          :totalPage="sysuserData.pages"
          :page="sysuserData.offset"
          @on-getList="sysuserPageChange"
          v-if="sysuserData.items && sysuserData.items.length !== 0"
        ></page>
      </template>
      <template v-if="agent==3">
        <table class="sysuser">
          <thead>
          <tr>
            <td>{{$t('common.Name')}}</td>
            <td>{{$t('common.Email')}}</td>
            <td>{{$t('common.SysNotification')}}</td>
          </tr>
          </thead>
          <tbody>
          <template
            v-if="businessUserData.items && businessUserData.items.length !== 0"
          >
            <tr v-for="(item, index) in businessUserData.items" :key="'businessUserData'+index">
              <td>{{ item.Name }}</td>
              <td>{{ item.Email }}</td>
              <td>
                <input type="checkbox" class="allSwitch" :id="'Buss' + index" v-model="item.IsInBusinessGroup" @change="isBussChange(item.Email)">
                <label :for="'Buss' + index"></label>
              </td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="4">{{$t('common.noData')}}</th>
          </tr>
          </tbody>
        </table>
        <page
          :totalPage="businessUserData.pages"
          :page="businessUserData.offset"
          @on-getList="bussUserPageChange"
          v-if="businessUserData.items && businessUserData.items !== 0"
        ></page>
      </template>
    </div>
    <!-- 编辑代理 对话框 -->
    <Dialog
      :show="agentEditShow"
      @cancel="agentEditCancel"
      @confirm="agentEditConfirm"
      :title="$t('common.EditDelegator')"
    >
      <div slot="content">
        <div class="edit_content">
          <div class="email">
            <div class="text">
              <span>*</span>
              <span>{{$t('common.Email')}}</span>
            </div>
            <div class="item_content p_r">
              <input
                type="text"
                :placeholder="$t('common.EmailPlaceHolder')"
                v-model="postData.editRolekey"
                @focus="searchUserFocus"
                @blur="searchUserBlur"
              />
              <transition name="email_list">
                <div class="agent_email p_a" v-if="agentEmailListShow">
                  <ul>
                    <template v-if="postData.editRolekey.length > 2">
                      <template v-if="agentEmailList.length > 0">
                        <li
                          v-for="(item, index) in agentEmailList"
                          :key="'agentEmailList'+index"
                          class="d_f c_p"
                          @click="editRolekeyChange(item)"
                        >
                          <span>{{ item.ConcatName }}</span>
                          <i class="icon iconfont icon-tianjiayonghu"></i>
                        </li>
                      </template>
                      <li v-else>
                        <div>{{$t('common.UserNotFound')}}</div>
                      </li>
                    </template>
                    <li v-else>
                      <div>{{$t('common.EmailSearchPlaceHolder')}}</div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
          <div class="already">
            <div class="text">
              <span>{{$t('common.SelectedDelegator')}}</span>
            </div>
            <div class="userList item_content">
              <template v-if="addEmailList && addEmailList.length !== 0">
                <div
                  class="user_item d_f"
                  v-for="(item, index) in addEmailList"
                  :key="'addEmailList'+index"
                >
                  <span>{{ item.EmployeeEmail }}</span>
                  <i
                    class="icon iconfont icon-lajitong c_p"
                    @click="delEmailList(item)"
                  ></i>
                </div>
              </template>
              <template v-if="backItem.Agents && backItem.Agents.length !== 0">
                <div
                  class="user_item d_f"
                  v-for="(item, index) in backItem.Agents"
                  :key="'Agents1'+index"
                >
                  <span>{{ item.AgentEmail }}</span>
                  <i
                    class="icon iconfont icon-lajitong c_p"
                    @click="agentDel(item)"
                  ></i>
                </div>
              </template>
              <div
                style="text-align: center;padding: 60px 0;font-size: 28px;color: rgb(202 200 195)"
                v-else
              >
                {{$t('common.NoDelegator')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 新增角色 对话框 -->
    <Dialog
      :show="sysuserAddShow"
      @cancel="sysuserAddCancel"
      @confirm="sysuserAddConfirm"
      :title="$t('common.AddUser')"
      width="34%"
      :overflow="true"
    >
      <div slot="content">
        <div>
          <div class="email">
            <div class="text">
              <span>*</span>
              <span>{{$t('common.Role')}}</span>
            </div>
            <div class="item_content">
              <allSelect
                :placeholder="$t('common.ChooseRolePlaceHolder')"
                :disabled="roleAddList && roleAddList.length > 0 ? false : true"
                :chooseData="roleAddList"
                :needReturn="'RoleName'"
                :matchValue="'RoleName'"
                :showValue="'{{RoleName}}'"
                v-model="postData.roleAddCode"
                :width="'84%'">
              </allSelect>
            </div>
          </div>
          <div class="email">
            <div class="text">
              <span>*</span>
              <span>{{$t('common.Email')}}</span>
            </div>
            <div class="item_content p_r">
              <input
                style="width:84%;padding: 6px 25px 6px 10px;border-radius: 50px;boxSizing: border-box;"
                :style="{
                  border:
                    roleAddList && roleAddList.length > 0
                      ? '1px solid rgb(182, 42, 64)'
                      : '1px solid #b62a40'
                }"
                type="text"
                :placeholder="$t('common.EmailPlaceHolder')"
                v-model="postData.roleAddEmail"
                :disabled="roleAddList && roleAddList.length > 0 ? false : true"
                @focus="searchUserFocus"
                @blur="searchUserBlur"
              />
              <transition name="email_list" v-if="agentEmailListShow">
                <div class="agent_email p_a">
                  <ul>
                    <template v-if="postData.roleAddEmail.length > 2">
                      <template v-if="agentEmailList.length > 0">
                        <li
                          v-for="(item, index) in agentEmailList"
                          :key="'agentEmailList'+index"
                          class="d_f c_p"
                          @click="checkEmail(item)"
                        >
                          <span>{{ item.ConcatName }}</span>
                        </li>
                      </template>
                      <li v-else>
                        <div>{{$t('common.UserNotFound')}}</div>
                      </li>
                    </template>
                    <li v-else>
                      <div>{{$t('common.EmailSearchPlaceHolder')}}</div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 删除其他角色 -->
    <Dialog
      :title="$t('common.DeleteUserMsg')"
      :show="sysuserDelShow"
      @cancel="sysuserDelCancel"
      @confirm="sysuserDelConfirm"
    />
  </div>
</template>

<script>
// 组件
import Dialog from '@/components/myComponents/dialog.vue'

export default {
  name: 'userManagement',
  data () {
    return {
      postData: {
        roleCode: '',
        editRolekey: '',
        roleAddCode: '',
        roleAddEmail: '',
        searchKey: '',
        onOffSelt: ''
      },
      // 下拉数据
      roleList: [
        {
          Code: '',
          Name: this.$t('common.All'),
          checked: true
        },
        {
          Code: 1,
          Name: 'ASM',
          checked: false
        },
        {
          Code: 2,
          Name: 'RSD',
          checked: false
        },
        {
          Code: 3,
          Name: 'NSD',
          checked: false
        },
        {
          Code: 4,
          Name: 'TS',
          checked: false
        }
      ],
      onOffSeltList: [
        {
          Code: '',
          Name: this.$t('common.All')
        },
        {
          Code: 'true',
          Name: 'ON'
        },
        {
          Code: 'false',
          Name: 'OFF'
        }
      ],
      // button切换角色
      agent: 1,
      // 销售代理 数据
      agentDta: {},
      // 控制 销售编辑对话框 显示/隐藏
      agentEditShow: false,
      agentEmailListShow: false,
      agentEmailList: [],
      businessUserData: [],
      // 点编辑的那一项的数据
      backItem: '',
      editRoleList: [],
      addEmailList: [],
      // 其他角色用户 列表
      sysuserData: {},
      sysuserAddShow: false,
      roleAddList: [],
      emailList: [],
      sysuserDelID: 0,
      sysuserDelShow: false,
      order: true
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.UserManagement')
  },
  methods: {
    checkEmail (item) {
      this.postData.roleAddEmail = item.EmployeeEmail
    },
    onOrderby () {
      this.order = !this.order
      this.getAgentList(this.agentDta.offset, 10)
    },
    searchUserFocus () {
      this.agentEmailListShow = true
    },
    searchUserBlur () {
      this.agentEmailListShow = false
    },
    // 头部下拉改变选项时触发
    searchEvent () {
      if (this.agent === 1) {
        this.getAgentList()
      } else if (this.agent === 2) {
        this.getSysuserList()
      } else if (this.agent === 3) {
        this.getBusinessUserList()
      }
    },
    onOffEvent () {
      this.getBusinessUserList()
    },
    isBussChange (email) {
      let data = []
      data.push(email)
      this.$axiox.put('/api/v1/admin/user/businessUser', data)
    },
    // 获取 销售代理 列表
    getAgentList (pageIndex = 1, pageSize = 10, sort) {
      this.$axiox.get(`/api/v1/admin/user/agent?pageIndex=${pageIndex}&pageSize=${pageSize}&key=${this.postData.searchKey}&role=${this.postData.roleCode}&sort=${!this.order ? 'name' : null}`)
        .then(res => {
          this.agentDta = res.data
        })
    },
    getBusinessUserList (pageIndex = 1, pageSize = 8) {
      let data = {
        pageIndex: pageIndex,
        pageSize: pageSize,
        key: this.postData.searchKey,
        isInBusinessGroup: this.postData.onOffSelt
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/user/businessUser', data)
      this.$axiox.get(url).then(msg => {
        this.businessUserData = msg.data || false
      })
    },
    allReset () {
      this.postData.searchKey = ''
      if (this.agent === 1) {
        this.postData.roleCode = ''
        this.getAgentList()
      } else if (this.agent === 2) {
        this.getSysuserList()
      } else if (this.agent === 3) {
        this.postData.onOffSelt = ''
        this.getBusinessUserList()
      }
    },
    // 点击 销售 编辑
    agentEdit (item) {
      this.agentEditShow = true
      this.backItem = JSON.parse(JSON.stringify(item))
    },
    // 点击添加代理
    editRolekeyChange (item) {
      if (
        this.backItem.Agents.some(items => {
          return items.AgentEmail === item.EmployeeEmail
        })
      ) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.UserAlreadyExists'),
          stayTime: 5
        })
      }
      this.addEmailList.unshift(item)
      this.postData.editRolekey = ''
      this.agentEmailListShow = false
    },
    // 点击 确定 销售对话框
    agentEditConfirm (val) {
      let emailList = []
      this.addEmailList.forEach(item => {
        emailList.push(item.EmployeeEmail)
      })
      this.backItem.Agents.forEach(item => {
        emailList.push(item.AgentEmail)
      })
      this.$axiox
        .post(`/api/v1/admin/user/agent`, {
          territoryCode: this.backItem.TerritoryCode,
          emailList
        })
        .then(res => {
          this.agentEditShow = val
          this.postData.editRolekey = ''
          this.addEmailList = []
          this.getAgentList(this.agentDta.offset, 10)
          if (res.success) {
            this.$commonJs.alertTips({
              type: 'success',
              content: this.$t('common.AddSuccess'),
              stayTime: 5
            })
          } else {
            this.$commonJs.alertTips({
              type: 'error',
              content: this.$t('common.AddFailed'),
              stayTime: 5
            })
          }
        })
    },
    // 点击 取消 销售对话框
    agentEditCancel (val) {
      this.agentEditShow = val
      this.agentEmailListShow = false
      this.postData.editRolekey = ''
      this.addEmailList = []
    },
    // 删除未提交的代理
    delEmailList (item) {
      this.addEmailList = this.addEmailList.filter(items => {
        return items.EmployeeEmail !== item.EmployeeEmail
      })
    },
    // 删除已提交的代理
    agentDel (item) {
      this.backItem.Agents.forEach((items, index) => {
        if (items.Id === item.Id) {
          this.backItem.Agents.splice(index, 1)
        }
      })
    },
    // 切换页数 销售
    agentPageChange (val) {
      this.getAgentList(val, 10)
    },
    // 获取 其他角色用户 列表
    getSysuserList (pageIndex = 1, pageSize = 10) {
      this.$axiox
        .get(
          `/api/v1/admin/user/sysuser?pageIndex=${pageIndex}&pageSize=${pageSize}&key=${this.postData.searchKey}`
        )
        .then(res => {
          this.sysuserData = res.data
        })
    },
    // 切换页数 其他角色
    sysuserPageChange (val) {
      this.getSysuserList(val, 10)
    },
    bussUserPageChange (val) {
      this.getBusinessUserList(val, 8)
    },
    onSysuserAddShow () {
      this.sysuserAddShow = true
      this.getRoleList()
    },
    // 获取角色列表
    getRoleList () {
      this.$axiox.get(`/api/v1/admin/role/list?pageSize=500`).then(res => {
        this.roleAddList = res.data.items
      })
    },
    // 根据 输入 查询用户
    getUser (pageIndex, pageSize, key) {
      this.$axiox
        .get(
          `/api/v1/admin/user/fuzzysearch?pageIndex=${pageIndex}&pageSize=${pageSize}&key=${key}`
        )
        .then(res => {
          this.agentEmailList = res.data.items
        })
    },
    sysuserAddCancel (val) {
      this.sysuserAddShow = val
      this.postData.roleAddEmail = ''
      this.postData.roleAddCode = ''
    },
    // 添加其他角色
    sysuserAddConfirm (val) {
      if (
        this.postData.roleAddCode === '' ||
        this.postData.roleAddEmail === ''
      ) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.RequiredFields'),
          stayTime: 5
        })
      } else {
        this.$axiox
          .get(
            `/api/v1/admin/user/fuzzysearch?key=${this.postData.roleAddEmail}`
          )
          .then(res => {
            if (res.data.items.length !== 0) {
              this.$axiox
                .post(`/api/v1/admin/user/sysuser`, {
                  role: this.postData.roleAddCode,
                  email: this.postData.roleAddEmail
                })
                .then(res => {
                  if (res.success) {
                    this.$commonJs.alertTips({
                      type: 'success',
                      content: this.$t('common.AddSuccess'),
                      stayTime: 5
                    })
                  } else {
                    this.$commonJs.alertTips({
                      type: 'error',
                      content: this.$t('common.AddFailed'),
                      stayTime: 5
                    })
                  }
                  this.sysuserAddShow = val
                  this.postData.roleAddEmail = ''
                  this.postData.roleAddCode = ''
                  this.getSysuserList(this.sysuserData.offset, 10)
                })
            } else {
              this.$commonJs.alertTips({
                type: 'error',
                content: this.$t('common.UserNotFound'),
                stayTime: 5
              })
            }
          })
      }
    },
    // 删除其他角色
    sysuserDel (item) {
      this.sysuserDelShow = true
      this.sysuserDelID = item.Id
    },
    // 关闭删除
    sysuserDelCancel (val) {
      this.sysuserDelShow = val
      this.sysuserDelID = 0
    },
    // 确定删除
    sysuserDelConfirm (val) {
      this.$axiox.del(`/api/v1/admin/user/${this.sysuserDelID}`).then(res => {
        if (res.success) {
          this.getSysuserList(this.sysuserData.offset, 10)
          this.sysuserDelShow = val
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.DeleteSuccess'),
            stayTime: 5
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            content: this.$t('common.DeleteFailed'),
            stayTime: 5
          })
        }
      })
    }
  },
  watch: {
    // 切换时 获取数据
    agent (val) {
      if (val === 1) {
        this.getAgentList()
      } else if (val === 2) {
        this.getSysuserList()
      } else {
        this.getBusinessUserList()
      }
    },
    // 编辑代理 搜索邮箱
    'postData.editRolekey': {
      handler (val) {
        if (val.length > 2) {
          this.getUser(1, 8, val)
        }
      },
      deep: true
    },
    'postData.roleAddEmail': {
      handler (val) {
        if (val.length > 2) {
          this.getUser(1, 8, val)
        }
      },
      deep: true
    }
  },
  created () {
    this.getAgentList()
  },
  components: {
    Dialog
  }
}
</script>

<style scoped>
  #userManagement {
    padding-bottom: 10px;
  }

  .top_select {
    margin: 10px 0;
  }

  .top_select span {
    display: inline-block;
    text-align: right;
    margin-right: 5px;
  }

  .top_select div {
    min-width: 160px;
    display: inline-block;
    vertical-align: middle;
  }

  .switch_role {
    display: flex;
    margin-top: 10px;
    padding-right: 10px;
    justify-content: space-between;
    align-items: center;
  }

  .button_group {
    font-size: 0;
  }

  .button_group span {
    display: inline-block;
    padding: 8px 0;
    width: 130px;
    color: #c50f3c;
    background-color: white;
    border: 1px solid #c50f3c;
    font-size: 12px;
    font-weight: 600;
  }

  .button_group span:nth-child(1) {
    border-top-left-radius: 6px;
  }

  .button_group span:nth-child(3) {
    border-top-right-radius: 6px;
  }

  .active {
    color: white !important;
    background-color: #c50f3c !important;
  }

  .year {
    color: #5c5e63;
    font-size: 13px;
    font-weight: 600;
  }

  .card {
    padding: 20px 8px 10px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 10px 1px rgb(214, 211, 211);
  }

  .sales {
    width: 100%;
    border-collapse: collapse;
  }

  thead {
    width: 100%;
    background-color: #fff1f4;
    border-bottom: 3px solid #e27f97;
    font-size: 13px;
    font-weight: 600;
  }

  tbody {
    width: 100%;
  }

  tr {
    width: 100%;
  }

  .email_list-enter-active,
  .email_list-leave-active {
    transition: all 0.4s;
  }

  .email_list-enter,
  .email_list-leave-to {
    opacity: 0;
  }

  .sales td {
    padding: 0.8% 0 0.8% 1%;
    box-sizing: border-box;
    white-space: normal;
  }

  .agent_del-enter-active,
  .agent_del-leave-active {
    transition: opacity 0.5s;
  }

  .agent_del-enter,
  .agent_del-leave-to {
    opacity: 0;
  }

  tbody {
    border-bottom: 2px solid #dfdfdf;
  }

  tbody tr:nth-of-type(even) {
    background-color: #f9f9f9;
  }

  th {
    text-align: center;
    color: #8b8686;
    padding: 40px;
    font-size: 14px;
    font-weight: 400;
  }

  .sysuser {
    width: 100%;
    border-collapse: collapse;
  }

  .sysuser td {
    padding: 0.8% 0 0.8% 2%;
    white-space: normal;
  }

  .edit_content {
    width: 80%;
    margin: 0 auto;
  }

  .email {
    margin-bottom: 20px;
  }

  .email .text:first-child {
    line-height: 29px;
  }

  .email .text span:first-child {
    color: #dd2352;
  }

  .text {
    float: left;
    width: 60px;
    text-align: right;
  }

  .item_content {
    margin-left: 80px;
  }

  .item_content input {
    width: 96%;
    padding: 6px 25px 6px 10px;
    border-radius: 50px;
    box-sizing: border-box;
    border: 1px solid rgb(182, 42, 64);
  }

  .userList {
    width: calc(100% - 100px);
    height: 300px;
    padding: 0px 4px;
    box-sizing: border-box;
    border: 1px solid #cc2d54;
    border-radius: 6px;
    overflow-y: scroll;
  }

  .userList::-webkit-scrollbar {
    width: 0px;
  }

  .user_item {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 13px;
  }

  .user_item img {
    height: 19px;
  }

  .user_item:nth-of-type(even) {
    background-color: #f8f5f5;
  }

  .user_item span {
    white-space: break-spaces;
  }

  .icon-bianji {
    color: #c50f3c;
    font-size: 19px;
  }

  .add_sysuser {
    margin-bottom: 10px;
    justify-content: flex-end;
  }

  .add_sysuser div {
    margin-right: 25px;
    padding: 4px 22px;
    color: white;
    font-size: 13px;
    background-color: #c50f3c;
    border-radius: 18px;
  }

  .add_sysuser i {
    color: white;
  }

  .agent_email {
    z-index: 2;
    top: 34px;
    left: 48%;
    transform: translate(-50%, 0);
    padding: 4px 16px;
    box-sizing: border-box;
    width: 94%;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 20px 1px #d4d5d6;
  }

  .agent_email li {
    justify-content: space-between;
    align-items: baseline;
    padding: 10px 8px;
    border-bottom: 1px solid #f1f1f1;
    font-size: 13px;
  }

  .agent_email li div {
    padding: 20px 0;
    text-align: center;
    color: rgb(158, 147, 147);
    font-size: 24px;
    white-space: normal;
  }

  .agent_email li:last-child {
    border: none;
  }

  .iconfont {
    color: #c50f3c;
    font-size: 18px;
  }

  .confirm div {
    background-color: #c50f3c;
    padding: 2px 6px;
    border-radius: 4px;
    color: white;
  }

  .confirm div:first-child {
    margin-right: 4px;
  }

  .daili div {
    margin-bottom: 10px;
  }

  .daili div:last-child {
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/UserManagement.vue